export class ImageMarkerPoint
{
	x;
	y;
	state;

	constructor(x, y, state)
	{
		this.x = x;
		this.y = y;
		this.state = state || 0;
	}

	hitTest(x, y, radius)
	{
		let dx = x - this.x;
		let dy = y - this.y;
		return (dx * dx + dy * dy) < (radius * radius);
	}
}

window.ImageMarkerPoint = ImageMarkerPoint;
